
import React from 'react';
import { Route } from 'react-router-dom';
import Auth from '@/pages/Auth';
import Portal from '@/pages/Portal';
import Dashboard from '@/pages/Dashboard';
import ProtectedRoute from '@/components/ProtectedRoute';
import RoleProtectedRoute from '@/components/RoleProtectedRoute';

export const AuthRoutes = () => (
  <>
    {/* Public Authentication Page */}
    <Route path="/auth" element={<Auth />} />
    
    {/* Patient Portal - Protected Route */}
    <Route 
      path="/portal" 
      element={
        <ProtectedRoute>
          <Portal />
        </ProtectedRoute>
      } 
    />
    
    {/* Main Dashboard - Protected Route */}
    <Route 
      path="/dashboard" 
      element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } 
    />
  </>
);
